var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"response btn btn-default border whitespace-no-wrap",class:{ selected: _vm.selected },style:({
        color: _vm.color,
        'background-color': _vm.bgColor,
        'border-color': _vm.response.color
    }),attrs:{"value":_vm.response.uuid},on:{"click":_vm.handleClick}},[_vm._v("\n    "+_vm._s(_vm.response.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }